import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMapPin } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-white text-black pt-24 pb-12 border-t border-black/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-20">
          <div className="col-span-1 md:col-span-1">
            <div className="flex flex-col mb-8 leading-none">
              <span className="text-3xl font-serif font-black tracking-tighter text-black uppercase">7601 CANADA</span>
              <span className="text-[10px] font-bold tracking-[0.3em] uppercase text-accent-orange mt-1">Suites</span>
            </div>
            <p className="text-black/60 text-sm leading-relaxed mb-8">
              Premium Orlando suites designed for short to mid-term stays. Experience more space, full kitchens, and zero resort fees, minutes from the world's top attractions.
            </p>
          </div>

          <div>
            <h4 className="text-[10px] font-bold uppercase tracking-[0.3em] text-accent-orange mb-8 text-center md:text-left">Explore</h4>
            <ul className="space-y-4 text-center md:text-left">
              <li><Link to="/" className="text-black/60 hover:text-black transition-colors text-sm uppercase font-bold tracking-widest">Home</Link></li>
              <li><Link to="/about" className="text-black/60 hover:text-black transition-colors text-sm uppercase font-bold tracking-widest">About</Link></li>
              <li><Link to="/310" className="text-black/60 hover:text-black transition-colors text-sm uppercase font-bold tracking-widest">Nature Green</Link></li>
              <li><Link to="/414" className="text-black/60 hover:text-black transition-colors text-sm uppercase font-bold tracking-widest">Royal Blue</Link></li>
              <li><Link to="/612" className="text-black/60 hover:text-black transition-colors text-sm uppercase font-bold tracking-widest">Cozy Grey</Link></li>
              <li><Link to="/amenities" className="text-black/60 hover:text-black transition-colors text-sm uppercase font-bold tracking-widest">Amenities</Link></li>
              <li><Link to="/nearby" className="text-black/60 hover:text-black transition-colors text-sm uppercase font-bold tracking-widest">Nearby</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] font-bold uppercase tracking-[0.3em] text-accent-orange mb-8 text-center md:text-left">Legal</h4>
            <ul className="space-y-4 text-center md:text-left">
              {['Privacy', 'Terms', 'Accessibility Statement'].map((item) => (
                <li key={item}>
                  <Link 
                    to={item === 'Accessibility Statement' ? '/accessibility-statement' : `/${item.toLowerCase().replace(' ', '-')}`} 
                    className="text-black/60 hover:text-black transition-colors text-sm uppercase font-bold tracking-widest"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] font-bold uppercase tracking-[0.3em] text-accent-orange mb-8 text-center md:text-left">Our Location</h4>
            <div className="space-y-6">
              <div className="flex gap-4 justify-center md:justify-start">
                <SafeIcon icon={FiMapPin} className="text-accent-orange w-5 h-5 flex-shrink-0" />
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=7601+Canada+Avenue+Orlando+FL+32819" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-black/60 hover:text-black transition-colors text-sm"
                >
                  7601 Canada Avenue, Orlando, FL 32819
                </a>
              </div>

              {/* QR Code Back Under Our Location Column */}
              <div className="flex flex-col items-center md:items-start pt-6 border-t border-black/5">
                <p className="text-[8px] font-bold uppercase tracking-[0.3em] text-black/40 mb-4">Visit Our Site</p>
                <div className="p-2 bg-white border border-black/10 rounded-lg inline-block">
                  <img 
                    src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://7601Canada.com" 
                    alt="QR Code to 7601Canada.com"
                    className="w-24 h-24 grayscale"
                  />
                </div>
                <p className="text-[10px] font-bold text-black mt-3 tracking-widest">7601CANADA.COM</p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-black/10 flex flex-col items-center text-center gap-4">
          <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-black/40">
            © {new Date().getFullYear()} 7601 CANADA. All rights reserved.
          </p>
          <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-black/40">
            <a 
              href="https://mobilefirstpro.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-accent-orange transition-colors flex items-center gap-2"
            >
              Made by <span className="text-black">Mobile First Pro</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;